export const IconTipLampLight20: {
  name: 'icon_tip_lamp_light_20-fcbcb309fd35'
} = {
  name: 'icon_tip_lamp_light_20-fcbcb309fd35'
}
